$(window).ready(function() {
  function initScrollMagic() {
    const animationController = new ScrollMagic.Controller();
    const backgroundImage =  document.querySelector('.speed-hero__background');
    const screenWidth = window.innerWidth;
    const isTabletPortrait = screenWidth >= 768 && screenWidth <= 1023;
    const hook = isTabletPortrait ? 0.6 : 1;

    const tl = new TimelineMax();
    tl.to(
      '.speed-hero__background .speed-hero__bg-image, .speed-hero__text-wrapper',
      {
        scale: 1,
        ease: Linear.easing,
      },
    )

    new ScrollMagic.Scene({
      duration: 700,
      triggerElement: backgroundImage,
      triggerHook: hook,
    })
    .setTween(tl)
    .removeClassToggle('.page-width')
    .addTo(animationController);
    
    new ScrollMagic.Scene({
      triggerElement: ".speed-hero__text--1, .speed-hero__text--2",
      triggerHook: hook
    })
    .setClassToggle(".speed-hero__text--1, .speed-hero__text--2", "active")
    .addTo(animationController);
    
    new ScrollMagic.Scene({
      triggerElement: ".speed-hero__text--3",
      triggerHook: hook
    })
    .setClassToggle(".speed-hero__text--3", "active")
    .addTo(animationController);
  }

  initScrollMagic();
})